import {
  QueryConstraint,
  QuerySnapshot,
  collection,
  documentId,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "shared/api/firebase";

export const hasTagByName = async (
  tagName: string,
  excludeTagId?: string,
): Promise<boolean> => {
  const collectionRef = collection(db, "tags");

  const params: QueryConstraint[] = [where("name", "==", tagName)];

  if (excludeTagId) {
    params.push(where(documentId(), "!=", excludeTagId));
  }

  const q = query(collectionRef, ...params);

  const querySnapshot: QuerySnapshot = await getDocs(q);

  return !querySnapshot.empty;
};
